import type { ReactNode } from "react";
import { Fragment } from "react";

interface Props {
  number: number;
  children: ReactNode;
}

const SkeletonList = ({ number, children }: Props) => (
  <>
    {Array.from({ length: number }).map((_, i) => (
      <Fragment key={"skeleton-" + i}>{children}</Fragment>
    ))}
  </>
);

SkeletonList.defaultProps = {
  number: 1,
};

export { SkeletonList };
